import React, { FC } from 'react';

const HAND_PATH = [
    'M7 10V4.5a1.2 1.2 0 0 1 2.4 0V9m0-5.5v-1a1.2 1.2 0 0 1 2.4 0V9m0-5a1.2 1.2 0 0 1 2.4 0V10',
    'm0-3a1.2 1.2 0 0 1 2.4 0v5.5A5.5 5.5 0 0 1 12.2 18H11a5 5 0 0 1-4-2l-3-4.2a1.3 1.3 0 0 1 2-1.6L7 12',
].join('');

const Icon: FC<{ children: React.ReactNode }> = ({ children }) => (
    <svg viewBox="0 0 20 20" aria-hidden="true">{children}</svg>
);

export const GridIcon: FC = () => (
    <Icon>
        <rect x="3" y="3" width="5" height="5" rx="1.2" />
        <rect x="12" y="3" width="5" height="5" rx="1.2" />
        <rect x="3" y="12" width="5" height="5" rx="1.2" />
        <rect x="12" y="12" width="5" height="5" rx="1.2" />
    </Icon>
);

export const CaretIcon: FC<{ className?: string }> = ({ className }) => (
    <svg className={className} viewBox="0 0 8 8" aria-hidden="true"><path d="M0 2h8L4 6z" /></svg>
);

export const HandIcon: FC = () => (
    <Icon>
        <path d={HAND_PATH} />
    </Icon>
);

export const ZoomOutIcon: FC = () => (
    <Icon>
        <circle cx="8.5" cy="8.5" r="5.5" />
        <path d="M12.6 12.6 17 17M6 8.5h5" />
    </Icon>
);

export const ZoomInIcon: FC = () => (
    <Icon>
        <circle cx="8.5" cy="8.5" r="5.5" />
        <path d="M12.6 12.6 17 17M6 8.5h5M8.5 6v5" />
    </Icon>
);

export const FitPageIcon: FC = () => (
    <Icon><rect x="5.5" y="3" width="9" height="14" rx="1" /></Icon>
);

export const FitWidthIcon: FC = () => (
    <Icon>
        <rect x="3" y="6" width="14" height="8" rx="1" />
        <path d="M3 3v14M17 3v14" />
    </Icon>
);

export const SearchIcon: FC = () => (
    <Icon>
        <circle cx="8.5" cy="8.5" r="5.5" />
        <path d="M12.6 12.6 17 17" />
    </Icon>
);

export const UpIcon: FC = () => <Icon><path d="M5 12l5-5 5 5" /></Icon>;

export const DownIcon: FC = () => <Icon><path d="M5 8l5 5 5-5" /></Icon>;

export const CloseIcon: FC = () => <Icon><path d="M5 5l10 10M15 5L5 15" /></Icon>;
